import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MatTableDataSource} from '@angular/material';
import {UsersService} from '../users.service';
import {FormControl} from '@angular/forms';
import {HttpParams} from '@angular/common/http';
import {UserPermisService} from '../user-permis/user-permis.service';
import {ToastrService} from 'ngx-toastr';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
	selector: 'kt-user-bracelets',
	templateUrl: './user-bracelets.component.html',
	styleUrls: ['./user-bracelets.component.scss']
})
export class UserBraceletsComponent implements OnInit {
	@Input() public id;
	@Input() public permission;
	subCategoryList = new MatTableDataSource<any>();
	eventList;
	selectedRow;
	braceletsList;
	visible: boolean = false;
	displayedColumns: string[];
	perm;
	name = new FormControl();

	constructor(private ngxPermissionService: NgxPermissionsService,private service1: UserPermisService, private service: UsersService, public activeModal: NgbActiveModal, private toastr: ToastrService) {
	}

	ngOnInit() {
		this.Visible();
		this.getData();
		this.getEvents();
		this.getAvailablebracelets();
		this.getDisplayedColumns();
	}

	getDisplayedColumns() {
		if (this.permission=='ADMIN' ) {
			this.displayedColumns = [
				'eventname',
				'braceletname',
				'functions'
			];
		} else {
			if (!this.visible || this.permission =='ALSUPERVISOR') {
				this.displayedColumns = [
					'eventname',
					'braceletname',
					'darab',
				];
			} else {
				this.displayedColumns = [
					'eventname',
					'braceletname',
					'darab',
					'functions'
				];
			}
		}

	}

	getData() {
		this.service.getBraceletLimitToSupervisor(this.id).subscribe((res) => {

			this.subCategoryList.data = res;
		});
	}

	Visible() {

		this.perm = this.ngxPermissionService.getPermissions().hasOwnProperty(this.permission);
		if(this.perm == this.permission){
			this.visible = false
		}else{
			this.visible = true
		}
		if(this.permission=='ALSUPERVISOR'){
			this.visible = false;
		}

	}

	removeSubCateg(item) {

		const index = this.subCategoryList.data.indexOf(item.id);
		this.subCategoryList.data.splice(item, 1);
		this.subCategoryList._updateChangeSubscription();
	}

	getEvents() {
		let params = new HttpParams();
		params = params.append('id', this.id);
		this.service1.getUserEvents(params).subscribe((res) => {
			this.eventList = res;
		});
	}

	getAvailablebracelets() {
		this.service.getAvailablebracelets(this.id).subscribe((res) => {
			this.braceletsList = res.bracelets;
		});
	}

	addSubcateg() {

		if (this.subCategoryList.data) {
			this.subCategoryList.data.push({
				eventId: '',
				braceletId: '',
				limit: ''
			});
		} else {
			this.subCategoryList.data = [];
		}
		this.subCategoryList.data = this.subCategoryList.data;
	}


	save() {
		const data = {
			userId: this.id,
			limits:
			this.subCategoryList.data

		};

		this.service.modifyBraceletLimitToSupervisor(data).subscribe((res) => {
				this.toastr.success('Sikeresen mentve', '');
				this.activeModal.close(true);
			}, (error) => {
				this.toastr.error(error.error.message, '', {timeOut: 5000});
			}
		);
	}

}
